import AEM from './aem';
import { initArms } from './arms';
import { initSmartTranslation } from './ai-trans';

initArms();
initSmartTranslation();

export { AEM };
